@if (currentToasts) {
  @for (toast of currentToasts; track toast; let i = $index) {
    <ngb-toast
      class="bg-dark text-light border border-1 shadow-lg mb-1"
      [ngClass]="{
        'border-success': toast.type === EventTypes.success,
        'border-danger': toast.type === EventTypes.error,
        'border-warning': toast.type === EventTypes.warning,
        'border-info': toast.type === EventTypes.info,
      }"
      [autohide]="toast.autohide"
      (hidden)="dispose(i)"
      [delay]="toast.delay"
      (mouseenter)="toast.autohide = false"
      (mouseleave)="toast.autohide = true">
      <span class="d-flex align-items-center">
        @if (toast.type === EventTypes.success) {
          <span class="d-inline material-icons text-success me-1">check</span>
        }
        @if (toast.type === EventTypes.info) {
          <span class="d-inline material-icons text-info me-1">info</span>
        }
        @if (toast.type === EventTypes.warning) {
          <span class="d-inline material-icons text-warning me-1">warning</span>
        }
        @if (toast.type === EventTypes.error) {
          <span class="d-inline material-icons text-danger me-1">warning_amber</span>
        }
        <span> {{ toast.message }}</span>
      </span>
    </ngb-toast>
  }
}
